import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import IndicadorHelpDialog from './IndicadorHelpDialog';
import { getEixoHelp, getIndicadorHelp } from '../../data/indicadores-help';

interface HelpButtonProps {
  /** Slug do eixo (ex: "c2-criancas") */
  eixo: string;
  /** Chave do indicador (ex: "A", "B"). Se omitido, mostra ajuda do eixo completo. */
  indicador?: string;
  /** Tamanho do icone em px (padrao: 16) */
  size?: number;
  /** Tooltip customizado. Se omitido, usa "Saiba mais sobre..." */
  tooltip?: string;
}

const HelpButton: React.FC<HelpButtonProps> = ({ eixo, indicador, size = 16, tooltip }) => {
  const [open, setOpen] = useState(false);

  // Verifica se ha dados de ajuda disponiveis
  const hasHelp = indicador ? !!getIndicadorHelp(eixo, indicador) : !!getEixoHelp(eixo);
  if (!hasHelp) return null;

  const eixoData = getEixoHelp(eixo);
  const indData = indicador ? getIndicadorHelp(eixo, indicador) : undefined;

  const tooltipText =
    tooltip ||
    (indData
      ? `Saiba mais sobre ${indData.nome}`
      : eixoData
        ? `Saiba mais sobre ${eixoData.nome}`
        : 'Ajuda');

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <Tooltip title={tooltipText} arrow placement="top">
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            width: size + 8,
            height: size + 8,
            opacity: 0.45,
            transition: 'opacity 0.2s ease, color 0.2s ease',
            color: 'text.secondary',
            '&:hover': {
              opacity: 1,
              color: 'primary.main',
              bgcolor: 'action.hover',
            },
          }}
          aria-label={tooltipText}
        >
          <HelpOutlineIcon sx={{ fontSize: size }} />
        </IconButton>
      </Tooltip>

      <IndicadorHelpDialog
        open={open}
        onClose={() => setOpen(false)}
        eixo={eixo}
        indicador={indicador}
      />
    </>
  );
};

export default HelpButton;
